module.exports = __webpack_public_path__ + "img/m-hd.6deddf49.jpg";